module.exports = __webpack_public_path__ + "static/media/shaker-1.4dcb1aa6.wav";